import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {history} from 'fn-common-ui';

import Modal from './modal';

@observer
export default class DiscardChangesModal extends React.Component {

  static propTypes = {
    isDirty: PropTypes.func,
    disabled: PropTypes.bool,
    clearForm: PropTypes.func,
    onHistoryChange: PropTypes.func
  }

  static defaultProps = {
    isDirty: () => false,
    disabled: false
  }

  constructor(props) {
    super(props);
    this.discardChangesModal = {};
    if(this.props.onHistoryChange) {
      this.unlisten = history.listen(this.props.onHistoryChange);
    }
  }

  componentDidMount() {
    //set up reroute blockade (returns unblocking function)
    this.unblock = history.block(({ location, retry }) => {
      if (this.props.isDirty() && !this.props.disabled) {
        this.interceptedRoute = location.pathname;
        this.retryNavigation = retry;
        // If this isn't a simple "skip navigation" click, show the exit modal and block the transition
        if(location.hash !== '#main-content'){
          this.discardChangesModal.showModal();
          return; //does not allow to proceed to new page
        }
      }
      // Form is not dirty - remove blocker and retry asynchronously to avoid infinite loop
      this.unblock();
      Promise.resolve().then(() => retry());
    });
  }

  componentWillUnmount() {
    //undo the reroute blockade and stop listening
    this.unblock();
    if(this.unlisten) {
      this.unlisten();
    }
  }

  onStay = (e) => {
    e.preventDefault();
    this.discardChangesModal.hideModal();
    this.interceptedRoute = '';
  }

  onGo = (e) => {
    e.preventDefault();
    this.discardChangesModal.hideModal();

    if(this.props.clearForm) {
      this.props.clearForm();
    }

    if(this.props.onHistoryChange) {
      this.props.onHistoryChange({pathname: this.interceptedRoute})
    }

    this.unblock();
    if (this.retryNavigation) {
      this.retryNavigation();
    } else {
      history.replace(this.interceptedRoute);
    }
  }

  render() {
    return (
      <Modal
        id="discardChangesModal"
        ref={i => {this.discardChangesModal = i}}
        primaryButtonLabel="No, stay here"
        primaryAction={this.onStay}
        secondaryButtonLabel="Yes, navigate anyway"
        secondaryAction={this.onGo}
        title="Unsaved Changes">
        <p>Are you sure you want to navigate away? Your unsaved changes will be lost.</p>
      </Modal>
    )
  }
}
